import { pickBy } from 'lodash';
import queryString from 'query-string';

export const skipEmptyStrings = (query) =>
  Object.keys(query)
    .filter((k) => query[k] !== '')
    .reduce((a, k) => ({ ...a, [k]: query[k] }), {});

export const addQueryParams = ({ navigate, location }, newParams) => {
  const currentParams = queryString.parse(location?.search);
  const mergedParams = { ...currentParams, ...newParams };

  navigate({
    search: queryString.stringify(
      pickBy(mergedParams, (v) => {
        if (v === null || v === undefined) return false;
        if (typeof v === 'string' && v.trim() === '') return false;
        return true;
      }),
    ),
    pathname: window.location.pathname,
  });
};
